// extracted by mini-css-extract-plugin
export var chip = "_fi-0";
export var filterDropdown = "_fi-5";
export var filterItem = "_fi-6";
export var icon = "_fi-1";
export var removeButton = "_fi-3";
export var removeIcon = "_fi-4";
export var separator = "_fi-2";